module.exports = __webpack_public_path__ + "static/media/question.4352baef.svg";